import React from 'react';

import { Heading } from 'Components/molecules/Heading';

class Error extends React.PureComponent {
  render() {
    return (
      <div className="polaris__body">
        <main className="polaris__main" id="main">
          <div className="polaris__content -body-copy -center">
            <Heading size={2}>
              Site Error
            </Heading>
            <p>It appears there is an error with the site. Apologies!</p>
            <p>Our team has been notified. Please reload and try again.</p>
          </div>
        </main>
      </div>
    );
  }
}
export default Error;
